import type { RouteRecordRaw } from "vue-router"
import { useSubscriptionStore } from "@/store/subscription-store"
import { sendToParent } from "@common/services/embed-service"
import { bootstrapEmbedContext } from "./embed-bootstrap"

import "./types"

const embedRoutes: RouteRecordRaw[] = [
  {
    path: "/embed",
    meta: { embeddable: true },
    component: () => import("@/modules/embed/employer-view/layouts/EmbeddedEmployerLayout.vue"),
    beforeEnter: async (to, from) => {
      const result = await bootstrapEmbedContext(to, from)
      if (result !== true) return result

      try {
        const subscriptionStore = useSubscriptionStore()
        await Promise.all([
          subscriptionStore.loadActiveCompanySubscription(),
          subscriptionStore.loadEntitlements(),
          subscriptionStore.loadBenefits()
        ])
      } catch (error) {
        console.error("[embed] Failed to load benefits state:", error)
        sendToParent("AUTH_ERROR", {
          code: "EMBED_BOOTSTRAP_FAILED",
          message: "Failed to initialize benefits state"
        })
        return false
      }

      return true
    },
    children: [
      {
        path: "employer-benefits",
        name: "embed-employer-benefits",
        component: () => import("@/modules/embed/employer-view/pages/EmbeddedBenefitsAdminPage.vue")
      },
      {
        path: "employer-benefits/benefits/:companyBenefitId",
        name: "embed-benefit-summary",
        component: () => import("@/modules/embed/employer-view/pages/EmbeddedBenefitSummaryPage.vue"),
        props: true,
        meta: {
          backRoute: "embed-employer-benefits"
        }
      },
      {
        path: "employer-benefits/hra-onboarding",
        name: "embed-hra-onboarding",
        component: () => import("@/modules/embed/employer-view/pages/EmbeddedHraOnboardingPage.vue"),
        meta: {
          backRoute: "embed-employer-benefits"
        }
      }
    ]
  },
  {
    path: "/embed/employer-billing",
    meta: { embeddable: true },
    component: () => import("@/modules/embed/employer-view/layouts/EmbeddedBillingLayout.vue"),
    beforeEnter: bootstrapEmbedContext,
    children: [
      {
        path: "",
        name: "embed-employer-billing",
        component: () => import("@/modules/embed/employer-view/pages/EmbeddedBillingPage.vue")
      }
    ]
  }
]

export default embedRoutes
